/**
 * Axios client configuration
 * Base configuration for all API calls
 */

import axios from 'axios';

const ENV_API_URL = import.meta.env.VITE_API_BASE_URL;
// Use relative path in development to route through Vite proxy
const API_BASE_URL = import.meta.env.VITE_ENVIRONMENT === 'development' 
  ? new URL(ENV_API_URL).pathname 
  : ENV_API_URL;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
